const cancel = 'Annulla'
const save = 'Salva'

export default {

  global: {
    generalError: 'Ops! Impossibile eseguire la richiesta. Per favore, ricarica la pagina.',
    signature: 'Cordiali saluti,',
  },

  component: {
    actionBar: {
      actions: 'Azioni',
      hideActions: 'Nascondi azioni',
    },

    addButton: {
      add: 'Aggiungi',
    },

    attachments: {
      add: 'Aggiungi CV o altri allegati richiesti',
      placeholderWithDescription: 'Aggiungi gli allegati richiesti',
      remove: 'Rimuovi',
      allowedFileTypes: 'Tipi di file consentiti',
      errors: {
        size: 'Il file è troppo grande, la dimensione massima consentita è di 5MB',
        empty: 'I\'l file non contiene dati',
        invalidType: fileType => `Ci dispiace, i file ${fileType} non sono ammessi per questioni di sicurezza`,
        typeNotWhitelisted: 'Siamo spiacenti, il tipo di file non è consentito.',
      },
    },

    agreeTos: {
      privacyLinkText: 'Informativa sulla privacy',
      termsLinkText: 'Termini e condizioni',
      privacyPolicyText: 'La tua privacy è importante per noi. Leggi la nostra ',
      termsText1: 'Leggere e accettare i ',
      termsText2: 'prima di fornirci i tuoi dati personali.',
      privacyLink: 'https://new.recright.com/privacy-policy',
      termsLink: 'https://new.recright.com/recright-terms-and-conditions-candidate',
      privacyInfo: mail => `Se non vuoi che elaboriamo i tuoi dati personali, puoi chiedere che vengano rimossi inviando una mail a ${mail}.`,
      customSupportPrivacyInfo: link => `Se non vuoi che elaboriamo i tuoi dati personali, puoi chiederne la rimozione scrivendo a ${link}.`,
    },

    buttons: {
      close: 'Chiudi',
    },

    competencies: {
      addCompetency: 'Aggiungi una nuovo competenza',
      edit: 'Modifica le competenze',
      done: 'Fatto',
      defaultsDescription: 'Se hai dubbi su quali competenze utilizzare, abbiamo creato alcuni modelli predefiniti con cui cominciare.',
      getDefaults: 'Ottieni competenze predefinite',
    },

    competency: {
      warning: 'Elimina la competenza e tutti i suoi utilizzi?',
    },

    confirmDelete: {
      delete: 'Elimina',
      cancel: 'Annulla',
      confirm: 'Conferma',
    },

    confirm: {
      cancel: 'Rimuovi registrazione',
      confirm: 'Riprova',
    },

    confirmButton: {
      wait: count => `Attendi ${count}`,
      confirm: 'Conferma',
    },

    controlStatus: {
      text: {
        empty: 'Riempi',
        valid: () => 'Pronto',
      },
      textarea: {
        empty: 'Riempi',
        valid: (length, limit) => `${length}/${limit}`,
      },
      select: {
        empty: 'Imposta',
        valid: () => 'Pronto',
      },
      file: {
        empty: 'Seleziona',
        valid: () => 'Cambia',
      },
      list: {
        empty: 'Aggiungi',
        valid: (length, limit) => `${length}/${limit}`,
      },
      search: {
        empty: 'Cerca',
        valid: () => 'Pronto',
      },
    },

    cookieConsentModal: {
      title: 'Il nostro sito Internet utilizza cookie',
      body: "Accettando tutti i cookie, accetti di conservarli sul tuo dispositivo per migliorare la navigazione del sito, per analizzarne l'uso e per contribuire alle nostre campagne di marketing.",
      learnMoreLinkText: 'Scopri come utilizziamo i cookie',
      learnMoreLink: 'https://new.recright.com/cookies/', // TODO add localized links when the page is translated
      manageCookies: 'Gestisci i cookie',
      acceptAll: 'Accetta tutti i cookie',
      manageTitle: 'Gestisci le preferenze di consenso',
      necessaryCookiesTitle: 'Cookie necessari',
      necessaryCookiesBody:
        'Questi cookie sono necessari per il funzionamento del sito Internet e non possono essere disattivati nei nostri sistemi.',
      performanceCookiesTitle: 'Cookie di prestazione',
      performanceCookiesBody:
        'Questi cookie ci permettono di contare le visite e le fonti di traffico in modo da valutare e migliorare le prestazioni del nostro sito Internet.',
      confirmChoices: 'Conferma le scelte',
      marketingCookiesTitle: 'Cookie di marketing',
      marketingCookiesBody:
        'Questi cookie ci consentono di personalizzare gli annunci pubblicitari e misurarne le prestazioni.',
      functionalCookiesTitle: 'Cookie di funzionalità',
      functionalCookiesBody:
        'Questi cookie vengono utilizzati per migliorare la funzionalità del sito web. Senza questi cookie alcune funzionalità potrebbero non essere disponibili. Esempi di cookie di funzionalità includono i servizi di chat web e le preferenze dell’utente.',
    },

    emailAddresses: {
      remove: 'Rimuovi',
      importCsv: 'Import CSV',
      invalidEmails: 'Trovate e-mail non valide.',
      maxCsvEntryErrorNotification: amount =>
        `Max ${amount} csv entries allowed`,
      importCsvTooltip:
        'Le righe CSV possono contenere un indirizzo e-mail oppure sia un indirizzo e-mail che un numero di telefono. Ogni riga rappresenta un destinatario. I numeri di telefono devono essere in formato internazionale (E.164), ad esempio <strong>+358</strong>50xxxxxxx.',
    },

    emailDeliveryStatus: {
      Undetermined: {
        Undetermined: 'E-mail respinta. Assicurati che il destinatario abbia ricevuto il tuo messaggio.',
      },
      Permanent: {
        General: 'Impossibile consegnare l\'e-mail. Il provider e-mail del destinatario ha respinto il messaggio.',
        NoEmail: 'L\'indirizzo e-mail non esiste.',
        Suppressed: 'L\'e-mail non è stata consegnata a causa di precedenti tentativi di consegna falliti.',
      },
      Transient: {
        General: 'E-mail respinta. Assicurati che il destinatario abbia ricevuto il tuo messaggio.',
        MailboxFull: 'La casella di posta del destinatario è piena.',
        MessageTooLarge: 'Il contenuto del messaggio è troppo grande.',
        ContentRejected: 'Il contenuto del messaggio è stato respinto.',
        AttachmentRejected: 'L\'allegato è stato respinto.',
      },
    },

    smsDeliveryStatus: {
      notDelivered: 'SMS message added to message queue, waiting for delivery.',
      failed: 'Sending SMS message failed.',
      duplicate: 'Il numero inserito è già associato a un candidato del colloquio.',
    },

    error403: {
      heading: 'Accesso vietato',
      content: 'Assicurati di aver effettuato l\'accesso all\'account corretto e di aver ricevuto un invito a visualizzare questa posizione su Recright. Assicurati inoltre di utilizzare Recright con una sola finestra del browser alla volta.',
      link: 'Prima pagina',
    },

    error404: {
      heading: 'Lì non c\'è nulla',
      content: 'Abbiamo cercato a fondo, ma non esiste alcuna pagina web all\'indirizzo da te richiesto. Forse hai seguito un link scaduto o hai accidentalmente inserito l\'indirizzo sbagliato.',
      link: 'Prima pagina',
    },

    error410: {
      heading: 'Chiuso',
      content: 'Il lavoro non può essere mostrato poiché è stato chiuso oppure il periodo di candidatura è terminato.',
      link: 'Prima pagina',
    },

    calendarError: {
      heading: 'Connecting calendar failed',
      content: 'We were unable to connect your calendar. Please try again later and if the issue continues please contact our support.',
    },

    flash: {
      starting: 'Inizializzazione...',
      connection_error_hint: 'Non è stato possibile stabilire una connessione alla rete.\nProva a ricaricare la pagina.',
      permission_hint: 'È necessario che autorizzi questo sito a utilizzare la tua webcam e il tuo microfono.',
      searching_camera_hint: 'Ricerca di una webcam in corso...',
      camera_reserved_hint: 'Un\'altra applicazione o pagina web sta utilizzando la tua webcam.\nChiudi tale applicazione e ricarica questa pagina.',
      camera_reserved_hint_chrome_extra: '\nGentili utilizzatore di Chrome, è necessario che autorizzi Recright a utilizzare la Webcam dalla casella di dialogo sotto la barra dell\'indirizzo.',
      no_camera_hint: 'Impossibile trovare la webcam.',
      no_mic_hint: 'Impossibile trovare il microfono.',
      uploading_text: 'Upload in corso...',
      rtmpt_in_use: 'Questo passaggio non sarebbe necessario se l\'amministratore\ndella tua rete autorizzasse il protocollo RMTP. Chiedici come fare.',
      preview_text: 'La webcam è in modalità anteprima',
      close_text: 'Chiudi videocamera',
      remove_text: 'Rimuovi registrazione',
      noflash_errortext_install: link => `Sembra che tu non abbia Adobe Flash Player. È necessario un plugin flash per registrare video. Procurati flash qui: ${link}`,
      noflash_errortext_enable: link => `Se hai flash già installato, ma vedi ancora questo messaggio, guarda qui: ${link}`,
      noflash_errortext_differentbrowser: 'In alternativa puoi provare a utilizzare un browser che supporti la registrazione HTML5. Ti suggeriamo Chrome o Firefox.',
    },

    footer: {
      terms: 'Termini e condizioni per gli utenti di Recright',
      license: 'Condizioni generali di servizio di Recright',
      privacyPolicy: 'Politica di riservatezza',
      customSupport: link => `Scrivi a ${link}`,
      accessibilityReport: 'Accessibility report',
    },

    feedbackPulse: {
      howWouldYouRateInterview: 'Come valuteresti la tua esperienza di colloquio?',
      howWouldYouRateJobAd: 'Come valuteresti l\'esperienza della candidatura?',
      yourResponseIsAnonymous: 'La tua risposta è anonima.',
      thankYouFeedback: 'Grazie per il tuo feedback!',
    },

    candidateFooter: {
      termsLink: 'https://new.recright.com/recright-terms-and-conditions-candidate',
      privacyPolicyLink: 'https://new.recright.com/privacy-policy',
      accessibilityReportLink: 'https://new.recright.com/hubfs/RecRight_Accessibility_report.pdf',
    },

    formErrors: {
      typeNotWhitelisted: 'Siamo spiacenti, il tipo di file non è consentito.',
      isRequired: 'Questo campo è obbligatorio.',
      isEmail: value => `${value} non è un indirizzo email valido.`,
      isDate: value => `${value} non è una data valida.`,
      invalidUrl: 'L\'URL non è valido.',
      singleHireEndError: 'L\'assunzione singola non può essere utilizzata per più di 60 giorni.',
      isNotTooOldForLive: 'La data è passata.',
      isNotAfterEndDate: 'La data selezionata non può essere successiva alla scadenza dell\'offerta di lavoro.',
      isValidMobilePhone: value => `${value ? `${value} is not` : 'Not'} a valid mobile phone number.`,
      isInternationalPhoneNumber: 'Phone number must be in international format.',
      duplicateNumber: 'Il numero di telefono è stato già aggiunto.',
      duplicateCompetency: 'Esiste già una competenza con quel nome',
      isNotDuplicateTemplateName:
        'Esiste già un modello di e-mail con questo nome.',
    },

    jobAdApplication: {
      name: 'Nome',
      email: 'Email',
      phone: 'Numero di telefono',
      city: 'Città',
      applyForPosition: 'Candidati per la posizione',
      back: 'Indietro',
      continue: 'Continua',
      submit: 'Invia',
      saveForLater: 'Continua più tardi',
      namePlaceholder: 'Inserisci il tuo nome',
      emailPlaceholder: 'Inserisci il tuo indirizzo email',
      phonePlaceholder: 'Inserisci il tuo numero di telefono',
      cityPlaceholder: 'Inserisci la città',
      links: 'Aggiungi link, per esempio quello del tuo profilo LinkedIn',
      legendLinks: 'Link',
      legendAttachments: 'Allegati',
      legendAdditionalFields: 'Informazioni aggiuntive',
      legendBasicInfo: 'Informazioni di base',
      coverLetter: 'Lettera di presentazione',
      attachments: 'Allegati',
      introduction: 'Scrivi qui una breve presentazione',
      thankYou: 'Grazie.',
      luck: 'Buona fortuna!',
      close: 'Chiudi',
      required: 'Gli elementi contrassegnati con un * asterisco sono obbligatori.',
    },

    jobAdContainer: {
      endTime: date => (date ? `attiva fino a ${date}` : ''),
    },

    jobAdDetails: {
      apply: 'Candidati per il lavoro',
    },

    jobAdQuickInterview: {
      back: 'Indietro',
      submit: 'Invia',
      saveForLater: 'Continua più tardi',
      title: 'Video-colloquio veloce',
      description: 'Per conoscerci più rapidamente desidereremmo che tu rispondessi brevemente alle nostre veloci domande del colloquio. Mettici la tua personalità e dai un\'anima alla tua candidatura.',
      requiredNote: 'Ricorda che questo fa parte del processo di candidatura, e che il recruiter riceverà la tua candidatura solo dopo che avrai registrato la tua risposta.',
      reminderNote: 'Puoi registrare subito la tua risposta, oppure puoi continuare più tardi ricevendo un promemoria sulla tua email.',
    },

    jobAdRow: {
      responses: 'Candidature',
      status: {
        open: 'Aperto',
        filled: 'Assegnata',
        cancelled: 'Annullata',
        done: 'Fatto',
        close: 'Chiudi',
        draft: 'Chiusa (bozza)',
        hidden: 'Nascosta',
      },
    },

    interviewRow: {
      responses: 'Candidati',
    },

    linkedInProfile: {
      showLinkedInProfileModal: 'Mostra profilo LinkedIn',
    },

    linkedInButton: {
      error: 'Impossibile recuperare il profilo. Riprova.',
      buttonText: 'Candidati con LinkedIn',
    },

    linkedInContainer: {
      linkedInButtonDescription: 'Puoi usare il tuo profilo LinkedIn per precompilare il modulo di domanda',
      linkedInOr: 'O',
      error: 'Impossibile recuperare il profilo. Riprova.',
    },

    linkListInput: {
      addField: 'Aggiungi',
      removeField: 'Rimuovi',
      invalidUrl: 'L\'URL non è valido.',
    },

    loadingButton: {
      loading: 'Caricamento...',
      saving: 'Salvataggio...',
      sending: 'Invio...',
    },

    modalApplicationForm: {
      applyForPosition: 'Candidati per la posizione',
      continue: 'Continua',
      name: 'Inserisci il tuo nome',
      email: 'Inserisci il tuo indirizzo email',
      phoneNumber: 'Inserisci il tuo numero di telefono',
      links: 'Puoi inserire dei link',
      legendLinks: 'Link',
      legendAttachments: 'Allegati',
      coverLetter: 'Lettera di presentazione',
      attachments: 'Allegati',
      introduction: 'Scrivi la tua presentazione qui',
      thankYou: 'Grazie.',
      luck: 'Buona fortuna!',
      close: 'Chiudi',
    },

    modalConfirm: {
      cancel,
      confirm: 'OK',
    },

    modalAlert: {
      close: 'Close',
    },

    modalLinkShare: {
      title: 'Link pubblico condivisibile',
      info: 'Questo è un indirizzo pubblico di un annuncio di lavoro che puoi condividere.\nChiunque sia interessato alla posizione può vedere l\'annuncio\ne quindi decidere di candidarsi.\nRiceverai la consueta notifica quando cominceranno ad arrivare candidature.\n\nQuesto è un link pubblico all\'annuncio di lavoro:',
    },

    modalVideoAdd: {
      title: 'Aggiungi un nuovo video',
      chooseTitle: 'Aggiungi un nuovo video',
      titlePlaceholder: 'Inserisci il titolo del video qui',
      cancel,
      save,
    },

    modalVideoUpload: {
      title: 'Carica un nuovo video',
      info: 'La dimensione massima per i video è di 500mb. Ti consigliamo di comprimere i video prima di caricarli, in questo modo il caricamento e la conversione richiederanno meno tempo.',
    },

    modalCandidateInfo: [
      {
        headline: 'Registra la tua video-risposta ',
        content: 'quante volte desideri. I video verranno salvati subito dopo la registrazione e potrai ritornare al video-colloquio attraverso il link ricevuto sulla tua email.',
        mobileContent: 'quante volte desideri. Aggiungi il video al colloquio. Vedrai il video aggiunto e salvato all\'interno del colloquio. Puoi ritornare al video colloquio utilizzando il link che hai ricevuto via mail. <br><br><strong>Se il video diventa nero e stai utilizzando un dispositivo Apple <a style="text-decoration: underline;" target="_blank" rel="noopener noreferrer" href="https://support.recright.com/en/articles/11187-recording-doesn-t-work-with-ipad-iphone">qui</a> troverai le istruzioni per risolvere l’ inconveniente.</strong>',
      },
      {
        headline: 'Una volta effettuata la registrazione, ',
        content: 'assicurati che il video si riproduca correttamente e che la tua voce sia udibile. Quando premerai sul pulsante "Invia", la tua risposta verrà bloccata e non potrai più modificarla.',
      },
      {
        headline: 'Quando avrai finito il colloquio, ',
        content: 'premi sul pulsante "Invia risposte e completa il colloquio". Dopo di ciò non potrai tornare al video-colloquio. Se desideri chiudere questa pagina ma continuare più tardi il colloquio, premi il pulsante "Continua più tardi".',
      },
      {
        headline: 'Se hai bisogno di aiuto ',
        content: mailto => `nel rispondere al video-colloquio, clicca sul pulsante "Aiuto" nell'area in basso a destra della pagina, oppure inviaci un messaggio via email ${mailto}.`,
        customContent: link => `Scrivi a ${link}`,
      },
    ],

    navigationBar: {
      back: 'Indietro',
      dashboard: 'Dashboard',
      frontpage: 'Prima pagina',
    },

    personDetails: {
      stage: 'Fase',
      namePlaceholder: 'Candidato',
      contact: 'Contattaci',
      referrer: 'Origine',
      referrerInfo: 'Il sito web attraverso il quale il candidato è giunto a utilizzare servizio.',
      links: 'Link',
      attachments: 'Allegati',
      coverLetter: 'Lettera di presentazione',
      noStage: 'Ancora in nessuna fase',
      lastSeen: time => `Visto l'ultima volta ${time}.`,
      headerAdditionalInformation: 'Informazioni aggiuntive',
      state: {
        invited: 'Invitato',
        visited: 'Visto',
        incomplete: 'Non Completato',
        completed: 'Completato',
      },
      notVisited: 'Non ha visualizzato il colloquio',
      scheduledInterview: 'Scheduled interview',
      scheduledInterviewInvitationSent: 'Invited to a meeting',
      scheduledInterviewInvitationExpired: 'Invitation has expired',
      scheduledInterviewInvitationEventCreated: 'Meeting:',
      scheduledInterviewReScheduleMeeting: 'Reschedule meeting',
      otherPersons: count => `Trovato anche in altre ${count} posizioni`,
    },

    phoneInput: {
      placeholder: example => `Telefono nel formato ${example}`,
    },

    questionsAndResponses: {
      response: 'Risposta',
      noResponse: 'Nessuna risposta',
      resetQuestionResponse: 'Cancella la risposta del candidato',
      resetQuestionResponseConfirm: questionTitle =>
        `Vuoi davvero ripristinare la domanda "${questionTitle}" per il candidato e cancellare la sua risposta?`,
      resetQuestionResponseConfirm2:
        'Se procedi, il candidato può rispondere nuovamente a questa domanda.',
    },

    rating: {
      ownVote: 'La tua valutazione',
      yourVotePlaceholder: 'Non hai ancora votato.',
      totalVotes: count => `${count} valutazioni in tutto`,
      mobileModalHeader: 'Aggiungi la tua valutazione',
      noRatings: 'Nessuna valutazione',
      yourRatingReset: 'Reimposta il tuo voto',
      averageRating: 'Valutazione media',
      reset: 'reimposta',
    },

    share: {
      share: 'Condividi su',
      copy: 'Copia link',
    },

    sort: {
      sort: 'Ordina',
    },

    supportLink: 'support@recright.com',

    typeSelect: {
      selected: 'Selezionato',
      change: 'Cambia',
    },

    video: {
      videoNotFound: 'Il video è in corso di elaborazione oppure non è stato trovato',
      retry: 'Riprova',
    },

    videoUpload: {
      uploadPlaceholder: isMobile => (isMobile ? 'Seleziona file' : 'Seleziona file'),
      videoPlaceholder: 'Registra la tua risposta',
      uploadPlaceholderCandidate: 'Carica un video',
      submit: 'Invia risposta',
      notAnswered: 'Non ha ancora risposto',
      remove: 'Rimuovi registrazione',
      converting: 'Conversione del video in corso. Si prega di attendere...',
      uploading: 'Caricamento del video in corso. Si prega di attendere...',
      error: {
        invalid: 'Il file selezionato è troppo grande. Per favore, seleziona un altro file.',
        upload: 'Ci dispiace, ma non è stato possibile caricare il video. Ti preghiamo di riprovare.',
        transcode: 'Il file video selezionato era corrotto e non valido, ti preghiamo di riprovare.',
      },
    },

    virtualBg: {
      showMoreButtonText: 'Mostra di più',
      showLessButtonText: 'Mostra di meno',
      infoText1:
        'Mantieni la scheda attiva in primo piano durante la registrazione. Non devi utilizzare altre applicazioni mentre registri.',
      infoText2:
        'Gli sfondi video funzionano meglio sui browser più recenti e con un dispositivo relativamente nuovo e potente.',
      infoText3:
        'Assicurati che altre applicazioni non stiano utilizzando il microfono o la fotocamera.',
    },

    videoResponse: {
      videoPlaceholder: 'Registra la tua risposta',
      uploadPlaceholder: 'Carica un video',
      submit: 'Invia risposta',
      notAnswered: 'Non ha ancora risposto',
      startInterview: 'Inizia il colloquio',
    },

    webcam: {
      useVideoBgButtonText: 'Usa sfondo video',
      removeVideoBgButtonText: 'Rimuovi sfondo video',
      starting: 'Avvio in corso...',
      close: 'Chiudi videocamera',
      remove: 'Rimuovi registrazione',
      record: 'Registra',
      stop: 'Stop',
      retake: 'Effettua nuova registrazione',
      submit: 'Invia risposta',
      converting: 'Conversione del video in corso. Si prega di attendere...',
      uploading: 'Caricamento del video in corso. Si prega di attendere...',
      downloading: 'È in corso il download del video. Ti preghiamo di attendere...',
      processing: 'Elaborazione...',
      uploadInProgress: 'Il trasferimento del video è ancora in corso, non chiudere il browser e non cambiare la pagina.',
      uploaded: 'Video trasferito.',
      error: {
        DevicesNotFoundError: 'Impossibile utilizzare la videocamera o il microfono. Per favore, controlla che siano attivati.',
        NotFoundError: 'Impossibile utilizzare la videocamera o il microfono. Per favore, controlla che siano attivati.',
        NotAllowedError: 'Non hai fornito il permesso necessario per utilizzare la videocamera o il microfono.',
        PermissionDismissedError: 'Hai chiuso la finestra di dialogo relativa al permesso. Per favore, fornisci il permesso di utilizzare la videocamera e il microfono.',
        PermissionDeniedError: 'Hai negato l\'accesso alla videocamera o al microfono.',
        NotReadableError: 'Impossibile leggere il flusso della videocamera o del microfono. È probabile che ci sia un problema nell\'hardware.',
        SecurityError: 'Impossibile utilizzare la videocamera o il microfono a causa di un errore di sicurezza',
        stream: 'Si è verificato un errore. Per favore, riavvia il tuo browser.',
        download: 'Download del video fallito. Riprovare?',
        upload: 'Caricamento del video fallito. Riprovare?',
        emptyBlob: 'La memoria del tuo browser o del tuo dispositivo è piena e non è possibile creare la registrazione. Per favore, aggiorna la pagina, e se ciò non aiuta, riavvia il browser.',
        alternativeRecorder: 'È possibile caricare file anche facendo clic qui.',
        reconnecting: 'La connessione si è interrotta. Tentativo di riconnessione in corso...',
      },
    },

    smsMessages: {
      invitationMessage: title =>
        `Ciao! Vogliamo invitarti a un videocolloquio: ${title}! Quest'invito sarà spedito anche via e-mail. `,
    },
  },
  page: {
    interviewPreview: {
      info: "Questa è un'anteprima del colloquio. La registrazione video è disattivata e i dati del modulo non vengono salvati.",
    },
  },
}
